<template>
    <div class="has-text-centered container azSize">
        <br><br>
        ADD WORD<br>
        <input id="inp" type="text" class="input is-warning" style="width: 200px" v-model="toAdd" /><br>
        <button class="button is-small is-warning top10" @click="doAdd" id="add" ref="addField" >ADD</button>
        <br><br><br>
    </div>
</template>

<script>

export default {
    mounted: function () {
        this.$refs.addField.focus();
        var self = this
    
        document.getElementById('inp').onkeypress = function(event){
            if(event.key.charCodeAt() == 69){ 
                self.doAdd()
            }
        }
    },

    data: function(){
        return {
            toAdd: ''
        }
    },

    methods: {
        doAdd: function(){
            if(this.toAdd == '')
                return

            var self = this
            function w(data){
                az.addRemSpinner(false, 'id', 'add')
                if(data == 'already'){
                    alert('already')
                }
                self.toAdd = ''
            }

            function n(e){
                az.addRemSpinner(false, 'id', 'add')
                alert('error')

            }

            az.addRemSpinner(true, 'id', 'add')
            this.$root.apiClient.post('api/account/addtowords', {val: this.toAdd}, w, n)
        }

    }
}

</script>


// WEBPACK FOOTER //
// src/pages/AddWords.vue